import { API_ENDPOINTS } from '../config/api'
import { safeJson } from '../lib/utils'
import { USE_MOCK_TPSM_INVENTORY_DATA } from './useMockTpsmInventory'
import { getMockAssessmentsBySupplierId } from './mockTpsmAssessmentsBySupplier'

/** GET /tpsm/assessments/:supplierId — uses mock data when `USE_MOCK_TPSM_INVENTORY_DATA` is on. */
export async function fetchTpsmAssessmentsForSupplier(
  supplierId: string,
  token: string | null | undefined,
): Promise<unknown[]> {
  if (USE_MOCK_TPSM_INVENTORY_DATA) {
    return getMockAssessmentsBySupplierId(supplierId)
  }
  const res = await fetch(API_ENDPOINTS.TPSM_ASSESSMENTS_SUPPLIER(supplierId), {
    headers: { Authorization: `Bearer ${token ?? ''}` },
  })
  const data = await safeJson(res)
  if (!res.ok) return []
  return Array.isArray(data) ? data : []
}
